// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ZoomInIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ZoomInIcon" ref={forwardedRef} {...props}>
      <path d="M11.526 12.855a6 6 0 1 1 1.4-1.429l3.817 3.817a1 1 0 1 1-1.415 1.414zM12.5 8a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0" />
      <path d="M7.251 8.749v2h1.5v-2h2v-1.5h-2v-2h-1.5v2h-2v1.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ZoomInIcon = /* @__PURE__ */ Object.assign(ZoomInIconComponent, {
  displayName: 'ZoomInIcon',
});
